export class AdminUserChartController {
  constructor($scope, UserService, $timeout, toastr) {
    this.scope = $scope;
    this.timeout = $timeout;
    this.toastr = toastr;
    this.UserService = UserService;

    this.init();
  }

  init() {
    this.scope.chartBar = {};
    this.scope.chartPieGender = {data: [], labels: []};
    this.scope.chartPieAge = {data: [], labels: []};

    this.scope.options = {
      legend: {
        display: true
      },
      responsive: true,
      maintainAspectRatio: false
    };

    this.scope.months = [
      {name: 'January', id: 0},
      {name: 'February', id: 1},
      {name: 'March', id: 2},
      {name: 'April', id: 3},
      {name: 'May', id: 4},
      {name: 'June', id: 5},
      {name: 'July', id: 6},
      {name: 'August', id: 7},
      {name: 'September', id: 8},
      {name: 'October', id: 9},
      {name: 'November', id: 10},
      {name: 'December', id: 11}
    ];

    this.scope.yearsNums = [];

    for(let i = 2016; i <= new Date().getFullYear(); i++) {
      this.scope.yearsNums.push(i);
    }

    this.scope.currentFetch = 'all';

    this.scope.filters = {
      usertype: {VIP: true, TRIAL: true, GIFT: true, USER: true},
      gender: {male: true, female: true},
      expired: {days:5}
    };

    this.scope.currentDateSelector = {
      loading: false,
      exporting: false,
      type: 'day',
      day: {
        model: new Date(),
        options: {
          datepickerMode: 'day',
          showWeeks: false,
          startingDay: 1
        }
      },
      week: {
        model: new Date(),
        options: {
          datepickerMode: 'day',
          showWeeks: true,
          startingDay: 1
        }
      },
      month: {
        model: {
          month: this.scope.months[new Date().getMonth()].id.toString(),
          year: this.scope.yearsNums[this.scope.yearsNums.length - 1]
        }
      },
      year: {
        model: this.scope.yearsNums[this.scope.yearsNums.length - 1]
      },
      range: {
        from: {
          options: {
            showWeeks: false,
            startingDay: 1
          },
          model: new Date()
        },
        to: {
          options: {
            showWeeks: false,
            startingDay: 1,
            minDate: new Date()
          },
          model: new Date().setDate(new Date().getDate() + 1)
        }
      }
    };

    this.scope.selectFor = (type) => {
      this.scope.currentDateSelector.type = type;
    };

    this.scope.fetchType = (type) =>{
      this.scope.currentFetch = type;
      this.scope.currentDateSelector.type = 'month';
    }

    this.scope.getData = () => {
      this.scope.currentDateSelector.loading = true;
      let options = this.getRange();
      options.filters = this.scope.filters;
      options.filters.filteredAge = this.getFilterAge(this.scope.filters.age);
      options.fetch = this.scope.currentFetch;
      this.UserService.getUserChart(options)
          .then((response) => { let data = response.data;
            this.scope.chartBar = data.chartBar;
            this.scope.chartPieAge = data.chartPieAge;
            this.scope.chartPieGender = data.chartPieGender;
            this.scope.currentDateSelector.loading = false;
          })
          .catch((response) => { let err = response.data;
            this.scope.currentDateSelector.loading = false;
            console.error(err);
          });
    };

    this.scope.exportExcel = () => {
      this.toastr.info('Getting data from the server', 'Information');
      this.scope.currentDateSelector.exporting = true;
      let options = this.getRange();
      options.filters = this.scope.filters;
      options.filters.filteredAge = this.getFilterAge(this.scope.filters.age);
      options.fetch = this.scope.currentFetch;
      this.UserService.getUserChartExport(options)
          .then((response) => { let data = response.data;
            this.scope.users = data.data;
            this.timeout(() => {
              var blob = new Blob([document.getElementById('exportable').innerHTML], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
              });
              FileSaver.saveAs(blob, "Report.xls");

              this.scope.currentDateSelector.exporting = false;
              this.toastr.success('Data exported to Report.xls!', 'Success');
            })
          })
          .catch((response) => { let err = response.data;
            this.scope.currentDateSelector.exporting = false;
            this.toastr.error('Something went wrong. Please, select a shorter date range or try later.', 'Error');
            console.error(err);
          });
    };

    this.scope.$watch('currentDateSelector.range.from.model', (val) => {
      switch (this.scope.currentDateSelector.type) {
        case 'range':
          this.scope.currentDateSelector.range.to.options.minDate = this.scope.currentDateSelector.range.from.model;

          if(this.scope.currentDateSelector.range.to.model <= this.scope.currentDateSelector.range.from.model) {
            this.scope.currentDateSelector.range.to.model = new Date(this.scope.currentDateSelector.range.from.model).setDate(new Date(this.scope.currentDateSelector.range.from.model).getDate() + 1)
          }
          break;
      }
    });

    this.scope.getData();
  }

  getRange() {
    switch(this.scope.currentDateSelector.type) {
      case 'day':
        return {
          from: moment.utc(this.scope.currentDateSelector.day.model).startOf('day').toISOString(),
          to: moment.utc(this.scope.currentDateSelector.day.model).endOf('day').toISOString(),
          group: 'dayOfYear',
          type: 'day'
        };
      case 'week':
        return {
          from: moment.utc(this.scope.currentDateSelector.week.model).startOf('week').toISOString(),
          to: moment.utc(this.scope.currentDateSelector.week.model).endOf('week').toISOString(),
          group: 'dayOfYear',
          type: 'week'
        };
      case 'month':
        return {
          from: moment.utc(`${this.scope.currentDateSelector.month.model.year}-${parseInt(this.scope.currentDateSelector.month.model.month) + 1}`, "YYYY-M").startOf('month').toISOString(),
          to: moment.utc(`${this.scope.currentDateSelector.month.model.year}-${parseInt(this.scope.currentDateSelector.month.model.month) + 1}`, "YYYY-M").endOf('month').toISOString(),
          group: 'dayOfYear',
          type: 'month'
        };
      case 'year':
        return {
          from: moment.utc(`${this.scope.currentDateSelector.year.model}`, "YYYY").startOf('year').toISOString(),
          to: moment.utc(`${this.scope.currentDateSelector.year.model}`, "YYYY").endOf('year').toISOString(),
          group: 'month',
          type: 'year'
        };
      case 'range':
        return {
          from: moment.utc(this.scope.currentDateSelector.range.from.model).startOf('day').toISOString(),
          to: moment.utc(this.scope.currentDateSelector.range.to.model).endOf('day').toISOString(),
          group: 'dayOfYear',
          type: 'range'
        };
      default:
        return {
          group: 'month',
          type: 'norange'
        };
    }
  }

  getFilterAge(param) {
    switch (param) {
      case '1': return {from: 18, to: 25};
      case '2': return {from: 26, to: 35};
      case '3': return {from: 36, to: 44};
      case '4': return {from: 45, to: 100};
      default: return {from: 18, to: 100};
    }
  }
}
